import React, { Suspense, useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import './assets/scss/style.scss'
import Spinner from './components/common/Spin'
import PropTypes from 'prop-types'
import { ensureSignedInAndGetToken, checkUserAuthorization } from './services/auth'
const Home = React.lazy(() => import('./features/home/home'))

// Pages
const Login = React.lazy(() => import('./pages/login/Login'))
const Page404 = React.lazy(() => import('./pages/page404/Page404'))
const Page500 = React.lazy(() => import('./pages/page500/Page500'))
const Unauthorized = React.lazy(() => import('./pages/unauthorized/unauthorized'))

const App = ({ pca }) => {
  const navigate = useNavigate()
  useEffect(() => {
    ;(async () => {
      try {
        await ensureSignedInAndGetToken(pca)

        // Check if user has authorization to access the application

        const hasAccess = checkUserAuthorization(pca)

        if (!hasAccess) {
          // User is authenticated but not authorized

          navigate('/unauthorized')
        }
      } catch (e) {
        const msg = String(e?.message ?? e)

        if (!msg.toLowerCase().includes('redirecting')) {
          console.error('Auth initialization error:', e)
        }
      }
    })()
  }, [pca, navigate])
  useEffect(() => {
    const script = document.createElement('script')

    const head = document.getElementsByTagName('head')[0]

    script.async = true

    script.type = 'text/javascript'

    script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-51632266-8'

    head.appendChild(script)

    window.dataLayer = window.dataLayer || []

    function gtag() {
      window.dataLayer.push(arguments)
    }

    gtag('js', new Date())

    gtag('config', 'UA-51632266-8', {
      anonymize_ip: true,

      allow_display_features: false,

      link_attribution: false,
    })
  }, [])

  return (
    <MsalProvider instance={pca}>
      <Suspense fallback={<Spinner fullscreen={false} />}>
        <Routes>
          <Route exact path="/" name="Login" element={<Login />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" name="Home" element={<Home />} />
        </Routes>
      </Suspense>
    </MsalProvider>
  )
}
App.propTypes = {
  pca: PropTypes.object,
}
export default App
